import { css } from "@emotion/react";
import Skeleton from "@mui/material/Skeleton";

import { colors } from "@dotnet/telematics-design-system";

import { RectangleLoaderProps } from "./types";

export const RectangleLoader = ({
    width,
    height,
    customStyle,
    backgroundColor,
    borderRadius,
    isWaveAnimation
}: RectangleLoaderProps) => {
    const { gray100 } = colors;

    return (
        <Skeleton
            data-testid="rectangle-loader"
            variant="rectangular"
            width={width}
            height={height}
            animation={isWaveAnimation ? "wave" : "pulse"}
            css={css([
                {
                    background: backgroundColor || gray100,
                    borderRadius: borderRadius || "6px"
                },
                customStyle
            ])}
        />
    );
};
